module.exports = __webpack_public_path__ + "img/check.a9b98317.png";